import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import {
  APPOINTMENT_STATUSES,
  DOCUMENT_ALLOWED_FORMATS,
} from '../../../../constants';
import { defaultState } from './UploadDocument/defaultState';
import { AddDocumentPopup } from './AddDocumentPopup';
import { UploadDocument } from './UploadDocument';
import { ViewDocuments } from './ViewDocuments';
import styles from './index.styl';

export function VisitDocuments({
  formatMessage,
  providerContext,
  appointment,
}) {
  const [isOpenModal, toggleOpenModal] = useState(false);
  const [attachment, setAttachment] = useState(defaultState);

  const titleDocuments = formatMessage({
    id: 'common.documents',
  });
  const titleAddButton = formatMessage({
    id: 'appointment.documents.addDocument.title',
  });

  const { id: appointmentId, allowedDocumentCategories, status } = appointment;

  const isPendingStatus =
    get(status, 'coreAppName') === APPOINTMENT_STATUSES.PENDING;

  const handleAddDocument = () => {
    toggleOpenModal(!isOpenModal);
  };

  return (
    <div className={styles.root}>
      <div className={styles.visitDocumentsHeader}>
        <div className={styles.visitDocumentsTitle}>{titleDocuments}</div>
        {providerContext && !isPendingStatus && (
          <div className={styles.addActionWrapper}>
            <UploadDocument
              attachment={attachment}
              setAttachment={setAttachment}
              handleAddDocument={handleAddDocument}
              titleAddButton={titleAddButton}
              allowedFormats={DOCUMENT_ALLOWED_FORMATS}
            />
          </div>
        )}
      </div>
      <ViewDocuments
        singleView={false}
        appointment={appointment}
        providerContext={providerContext}
        formatMessage={formatMessage}
      />
      <AddDocumentPopup
        onClose={handleAddDocument}
        opened={isOpenModal}
        formatMessage={formatMessage}
        attachment={attachment}
        setAttachment={setAttachment}
        appointmentId={appointmentId}
        allowedDocumentCategories={allowedDocumentCategories}
      />
    </div>
  );
}

VisitDocuments.propTypes = {
  formatMessage: PropTypes.func,
  providerContext: PropTypes.bool,
  appointment: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/index.jsx